const skills = [
  { icon: 'ri-chat-3-line', title: 'Коммуникация', desc: 'Объяснять изменения понятно и своевременно, отвечать на вопросы и не оставлять сотрудников в неопределённости.' },
  { icon: 'ri-vip-crown-line', title: 'Лидерство', desc: 'Вести команду через неопределённость, сохраняя направление и уверенность людей.' },
  { icon: 'ri-mental-health-line', title: 'Эмоциональный интеллект', desc: 'Понимать эмоциональные реакции людей и управлять собственным состоянием в напряжённые периоды.' },
  { icon: 'ri-shake-hands-line', title: 'Переговоры', desc: 'Договариваться с сотрудниками и заинтересованными сторонами, отстаивать интересы без давления.' },
  { icon: 'ri-fire-line', title: 'Работа с конфликтами', desc: 'Не допускать, чтобы сопротивление превращалось в разрушительный конфликт.' },
  { icon: 'ri-list-check-2', title: 'Постановка задач', desc: 'Переводить изменения в конкретные действия, сроки и критерии результата.' },
  { icon: 'ri-dashboard-line', title: 'Контроль', desc: 'Отслеживать внедрение нового поведения, а не только факт выполнения.' },
  { icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Корректировать действия сотрудников, помогая им осваивать новый способ работы.' },
  { icon: 'ri-star-line', title: 'Мотивация', desc: 'Понимать, что помогает людям включаться в изменения, а не саботировать их.' },
];

export default function ChangeSkills() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Управление изменениями как навык руководителя
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Какие компетенции необходимо развивать, чтобы проводить команду через изменения
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((s) => (
            <div key={s.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}